import { makeStyles } from "@material-ui/core";
import Theme from "../.themes/common/Theme";

export const useStyles = makeStyles((theme: Theme) => ({
  popover: {
    background: "rgba(0,0,0,0.5)",
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    position: "relative",
  },
  popup: {
    maxWidth: 1016,
    minWidth: 320,
    "& .MuiButton-contained .MuiButton-label::after": {
      content: "none",
    },
    "& .text-area": {
      "& p": {
        margin: 0,
      },
      "& .button-primary": {
        boxSizing: "border-box",
        appearance: "none",
        userSelect: "none",
        transition: "all 0.35s ease-out",
        display: "inline-flex",
        cursor: "pointer",
        padding: "0 24px",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1rem",
        marginTop: 8,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.colorCard?.primary || theme.palette?.primary?.main}`,
        background: theme.colorCard?.primary || theme.palette?.primary?.main,
        color: theme.colorCard?.background || theme.palette?.primary?.contrastText,
        minHeight: "48px",
        minWidth: "200px",
        lineHeight: "24px",
        textDecoration: "none",
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },
        fontFamily: theme.typography.fontFamily,

        "&:hover, &:focus": {
          backgroundColor: theme.colorCard?.primaryHover || theme.palette?.primary?.dark,
          border: `1px solid ${theme.colorCard?.primaryHover || theme.palette?.primary?.dark}`,
          textDecoration: "none",
          color: theme.colorCard?.background || theme.palette?.primary?.contrastText,
        },
        "& a": {
          textDecoration: "none",
          color: theme.colorCard?.background || theme.palette?.primary?.contrastText,
          "&:hover": {
            textDecoration: "none",
            color: theme.colorCard?.background || theme.palette?.primary?.contrastText,
          },
        },
      },
      "& .button-secondary": {
        boxSizing: "border-box",
        appearance: "none",
        userSelect: "none",
        transition: "all 0.35s ease-out",
        display: "inline-flex",
        cursor: "pointer",
        padding: "0 24px",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1rem",
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.colorCard?.primary || theme.palette?.primary?.main}`,
        background: theme.colorCard?.background || theme.palette?.primary?.contrastText,
        color: theme.colorCard?.primary || theme.palette?.primary?.main,
        minHeight: "48px",
        minWidth: "200px",
        lineHeight: "24px",
        textDecoration: "none",
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },

        "&:hover, &:focus": {
          border: `1px solid ${theme.colorCard?.primaryHover || theme.palette?.primary?.dark}`,
          color: theme.colorCard?.background || theme.palette?.primary?.contrastText,
          backgroundColor: theme.colorCard?.primaryHover || theme.palette?.primary?.dark,
          textDecoration: "none",
        },

        "& a": {
          textDecoration: "none",
          color: theme.colorCard?.primary || theme.palette?.primary?.main,
          "&:hover": {
            textDecoration: "none",
            color: theme.colorCard?.primary || theme.palette?.primary?.main,
          },
        },
      },
      "& ul": {
        "&.check": {
          paddingLeft: 0,
          listStyleType: "none",
          "& li": {
            background: `url("data:image/svg+xml;utf8,${theme.icons?.checkmarkIconCSS ?? ""}") no-repeat 0 2px`,
            backgroundSize: "25px 25px;",
            paddingLeft: theme.spacing(5) + "px",
            marginBottom: "22px",
            lineHeight: "28px",
            minHeight: "30px",
            marginLeft: 0,
            [theme.breakpoints.down("sm")]: {
              fontSize: "1rem",
              lineHeight: "28px",
              minHeight: "27px",
            },
          },
        },
      },
    },
    ...theme.popup?.root,
  },
  header: {
    padding: `16px 32px`,
    background: "rgba(0,0,0,0.2)",
    [theme.breakpoints.down("sm")]: {
      padding: 16,
    },
    ...theme.popup?.headerBackground,
  },
  body: {
    padding: 32,
    minWidth: 800,
    [theme.breakpoints.down("sm")]: {
      padding: 16,
      minWidth: 300,
    },
  },
  h4: {
    ...theme.popup?.h4,
  },
  closeIcon: {
    textAlign: "right",
  },
  image: {
    objectFit: "cover",
    minWidth: 360,
    width: "100%",
    borderRadius: 4,
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "none",
      minWidth: 260,
    },
  },
  imageGrid: {
    display: "flex",
    alignSelf: "stretch",
    minWidth: 360,
    [theme.breakpoints.down("sm")]: {
      minWidth: 280,
    },
  },
  textBlock: {
    paddingRight: 16,
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: 16,
      paddingRight: 0,
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  addButton: {
    cursor: "pointer",
    padding: "0 24px 0 16px",
    marginTop: 16,
    "&.MuiButton-root": {
      width: "auto",    
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      }
    },
    "& .button-text": {
      marginLeft: "8px",
      marginTop: "2px",
    },
  },
}));
